<div class="PolicyDashboards">
  <div class="Loading" *ngIf="isShowLoading==true">
    <img id="" src="assets/img/762.gif" />
    <label>{{'Please Wait,Processing..'|translate }}</label>
  </div>

  <div class="container-fluid">





    <div class="row">
      <div class="col-md-12">
        <!-- Nav tabs -->
        <div class="card InsuranceModel" id="InsuranceModel">
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Motor'|translate}}</a>
            </li>
            <li role="presentation">
              <a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">{{'Travel'|translate}}</a>
            </li>
            <li role="presentation">
              <a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">{{'Medical Mal'|translate}}</a>
            </li>
            <!-- <li role="presentation">
                            <a href="#Domestic" aria-controls="messages" role="tab"
                                data-toggle="tab">{{'Domestic Helper'|translate}}</a>
                        </li> -->

          </ul>

          <!-- Tab panes -->
          <div class="tab-content ProposalPage">



            <div role="tabpanel" class="tab-pane active" id="home">

              <div class="row">
                <div class="col-md-12 proposals">

                  <div class="panel panel-default panel-table">
                    <div class="panel-heading">
                      <div class="row">
                        <div class="col col-xs-12">
                          <h3 class="panel-title"> {{'My Motor Proposals'|translate}}</h3>
                        </div>

                      </div>
                    </div>
                    <div class="panel-body">
                      <table class="table table-striped table-bordered table-list">
                        <thead>
                          <tr>
                            <th>{{'Proposal No'|translate}}</th>
                            <th *ngIf="false">{{'Insured Name'|translate}}</th>
                            <th *ngIf="false">{{'Product'|translate}}</th>
                            <th>{{'Proposal Type'|translate}}</th>
                            <th>{{'From Date'| translate }}</th>
                            <th>{{'Expiry Date'| translate }}</th>
                            <th>{{'TPL Premium'|translate}}</th>
                            <th>{{'Comprehensive Premium'|translate}}</th>
                            <!-- <th>{{'Sadad BillNo'|translate}} </th>
                                                        <th>{{'Sadad BillExp'|translate}} </th> -->
                            <th>{{'Status'|translate}} </th>
                            <th>{{'Action'|translate}}</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let proposal of proposalList;let idx=index">
                            <!-- <td *ngIf="(proposal.isProposalEdit && proposal.isActive==true)"><a (click)="goForEdit(proposal)" > {{proposal.ProposalNo}}</a></td>
                                                                                            <td *ngIf="(!proposal.isProposalEdit || proposal.isActive==false)"> {{proposal.ProposalNo}}</td>-->
                            <td>{{proposal.ProposalNo}}</td>
                            <td *ngIf="false">{{proposal.Name}}</td>
                            <td *ngIf="false">{{proposal.ProductDesc}}</td>
                            <td>{{proposal.ProposalType | translate}}</td>
                            <td>{{proposal.ProposalFrom }}</td>
                            <td style="color:red;font-weight:bold;">{{proposal.ProposalTo }}
                            </td>
                            <td>
                              <span *ngIf="this.Lng=='ar'">(SAR){{proposal.TPLTotalPremium}}</span>
                              <span *ngIf="this.Lng!='ar'">{{proposal.TPLTotalPremium}}(SAR)</span>
                            </td>
                            <td>
                              <span *ngIf="this.Lng=='ar'">(SAR){{proposal.CompTotalPremium}}</span>
                              <span *ngIf="this.Lng!='ar'">{{proposal.CompTotalPremium}}(SAR)</span>
                            </td>
                            <!-- <td>{{proposal.SadadBillNo }}</td>
                                                        <td>{{proposal.SadadBillExp }}</td> -->
                            <td [ngClass]="{
                                                            'ProposalstatusActive':proposal.isActive==true,
                                                            'ProposalstatusInActive':proposal.isActive==false                                                           
                                                          }">{{proposal.Status | translate}}</td>
                            <td>
                              <!-- Actionbtndropdown -->
                              <ul class="Actionbtndropdown">
                                <li class="ActiondropdownITEM">
                                  <button (click)="btnClick(idx)" class=" btn btnDropdown" href="#" style="color: white !important">{{'Action'|translate}}
                                    <span class="glyphicon glyphicon-chevron-down" style="font-size: 10px;"></span>
                                  </button>
                                  <ul class="actionUL">
                                    <li>
                                      <a href="#" *ngIf="!(proposal.PaymentStatus==1 || proposal.isActive==false || proposal.TPLTotalPremium==0) && ((proposal.ProposalType=='RENEWAL' && proposal.ProductCode=='5515') || (proposal.ProposalType=='NEW'))" (click)="goforPayment(proposal,'5515')">
                                        <span class="glyphicon glyphicon-share"></span>
                                        {{'Purchase Tpl' | translate }}

                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" *ngIf="!(proposal.PaymentStatus==1 || proposal.isActive==false || proposal.CompTotalPremium==0) && ((proposal.ProposalType=='RENEWAL' && proposal.ProductCode=='5520') || (proposal.ProposalType=='NEW'))" (click)="goforPayment(proposal,'5520')"><span class="glyphicon glyphicon-share"></span>
                                        {{'Purchase Comp' | translate }}

                                      </a>
                                    </li>
                                    <li><a href="#" *ngIf="!(proposal.PaymentStatus==1 || proposal.isActive==false  || (proposal.ProductCode=='5520' && proposal.ProposalType=='RENEWAL') || (proposal.ProductCode=='5515' && proposal.ProposalType=='RENEWAL')  || proposal.SadadBillNo!='' || proposal.ProposalType=='UPGRADE')" (click)="goForEdit(proposal)"><span class="glyphicon glyphicon-edit"></span>
                                        {{'Edit' | translate }}
                                      </a>
                                    </li>
                                    <li><a href="#" *ngIf="!(proposal.PaymentStatus==1 || proposal.isActive==false)" (click)="CancelProposal(proposal.cancelObj)"><span class="glyphicon glyphicon-remove"></span>
                                        {{'Cancel' | translate }}
                                      </a>
                                    </li>
                                    <li>
                                      <a *ngIf="(proposal.ProposalType=='RENEWAL' && proposal.ProductCode=='5515') || (proposal.ProposalType=='NEW')" href="{{url.PrintURL}}/MOTOR/ProposalDL.aspx?strParm={{proposal.DownLoadProposal_Tpl}}:{{ProposalLan}}" download="myPolicy" class="" style="border-top: none !important;border-left: none !important;" target="_blank"><span class="glyphicon glyphicon-save"></span>
                                        {{'Tpl' | translate }}</a>
                                    </li>
                                    <li>
                                      <a *ngIf="(proposal.ProposalType=='RENEWAL' && proposal.ProductCode=='5520') || (proposal.ProposalType=='NEW')" href="{{url.PrintURL}}/MOTOR/ProposalDL.aspx?strParm={{proposal.DownLoadProposal_Comp}}:{{ProposalLan}}" download="myPolicy" class="" style="border-top: none !important;border-left: none !important;" target="_blank"><span class="glyphicon glyphicon-save"></span>
                                        {{'Comp' | translate }}</a>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                              <!-- Actionbtndropdown -->
                            </td>

                          </tr>
                        </tbody>
                      </table>

                    </div>

                  </div>

                </div>
              </div>

            </div>

            <div role="tabpanel" class="tab-pane" id="profile">
              <div class="row">
                <div class="col-md-12 proposals">

                  <div class="panel panel-default panel-table">
                    <div class="panel-heading">
                      <div class="row">
                        <div class="col col-xs-12">
                          <h3 class="panel-title">{{'My Travel Proposals'|translate}}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="panel-body">
                      <table class="table table-striped table-bordered table-list">
                        <thead>
                          <tr>
                            <th>{{'Proposal No'|translate}}</th>
                            <th>{{'Travel From'|translate}}</th>
                            <th>{{'Travel To'|translate}}</th>
                            <th>{{'Proposal Expiry Date'|translate}}</th>
                            <th>{{'Scheme/Plan'|translate}}</th>
                            <th>{{'Sadad BillNo'|translate}} </th>
                            <th>{{'Sadad BillExp'|translate}} </th>
                            <th>{{'Premium'|translate}}</th>
                            <th>{{'Status'|translate}} </th>
                            <th>{{'Action'|translate}}</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let proposal of travelProposalList">
                            <!--<td *ngIf="proposal.isProposalEdit"><a (click)="goForTravelEdit(proposal)" > {{proposal.ProposalNo}}</a></td>
                                                                    <td *ngIf="!proposal.isProposalEdit"> {{proposal.ProposalNo}}</td>-->
                            <td>{{proposal.ProposalNo}}</td>
                            <!-- <td>{{proposal.Name}}</td> -->
                            <!--  <td>{{proposal.ProductDesc}}</td>
                                                                    <td>{{proposal.ProposalType}}</td>-->
                            <td>{{proposal.TravelFromDate}}</td>
                            <td>{{proposal.TravelToDate}}</td>
                            <td style="color:red">{{proposal.ProposalToDate}}</td>
                            <td>{{proposal.ZoneDescription_En }}/{{ proposal.PlanDesc_Eng}}
                            </td>
                            <td>{{proposal.SadadBillNo }}</td>
                            <td>{{proposal.SadadBillExp }}</td>
                            <td>{{proposal.TotalPremium}}</td>
                            <td>{{ proposal.Status | translate}}</td>
                            <td>
                              <button class="btn btn-primary btn-sm" disabled *ngIf="!(proposal.PaymentStatus==1 || proposal.ProposalExpiryStatus=='Expired' || proposal.PaymentExpiryStatus=='Expired' ||proposal.Status=='Expired')" (click)="goforTravelPayment(proposal)">{{'Pay' |translate}}</button>
                              <button class="btn btn-primary btn-sm" [disabled]="proposal.PaymentStatus==1 || proposal.ProposalExpiryStatus=='Expired' ||proposal.Status=='Expired' || proposal.SadadBillNo!='' " (click)="goForTravelEdit(proposal)">{{'Edit' |translate}}</button>
                              <button class="btn btn-primary btn-sm" disabled (click)="goForTravelCancel(proposal.cancelObj)">{{'Cancel' |translate }}</button>

                              <!-- <a class="btn btn-primary btn-sm"
                                                                href="{{url.PrintURL}}{{proposal.proposalFileName}}:{{ProposalLan}}"
                                                                download="myProposal" target="_blank"
                                                                *ngIf="proposal.ProposalExpiryStatus!='Expired'||proposal.Status=='Expired'">{{'Download'|translate}}</a> -->

                              <a class="btn btn-primary btn-sm" href="{{url.PrintURL}}TRAVEL/rpt_ProposalPrintEng_Travel.aspx?strParm={{proposal.ProposalNo}}" target="_blank" *ngIf="proposal.ProposalExpiryStatus!='Expired'||proposal.Status=='Expired'">{{'Download'|translate}}</a>

                            </td>

                          </tr>

                        </tbody>
                      </table>

                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div role="tabpanel" class="tab-pane" id="messages">
              <div class="row">
                <div class="col-md-12 proposals">

                  <div class="panel panel-default panel-table">
                    <div class="panel-heading">
                      <div class="row">
                        <div class="col col-xs-12">
                          <h3 class="panel-title">{{'My Medmal Proposals'|translate}}</h3>
                        </div>
                        <!-- <div class="col col-xs-6 text-right">
                                                                            <button type="button" class="btn btn-sm btn-primary btn-create">Create New</button>
                                                                          </div> -->
                      </div>
                    </div>
                    <div class="panel-body">
                      <table class="table table-striped table-bordered table-list">
                        <thead>
                          <tr>
                            <th>{{'Proposal No'|translate}}</th>
                            <th>{{'Proposal Type'|translate}}</th>
                            <th>{{'Scheme'|translate}}</th>
                            <th>{{'From Date'| translate }}</th>
                            <th>{{'Expiry Date'| translate }}</th>
                            <th>{{'Premium'|translate}}</th>
                            <th>{{'Status'|translate}} </th>
                            <th>{{'Action'|translate}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let proposal of medmalProposalList">
                            <td>{{proposal.ProposalNo}}</td>
                            <td>{{proposal.proposalflag}}</td>
                            <td>{{proposal.SchemeDesc}}</td>
                            <td>{{proposal.ProposalEffFrom}}</td>
                            <td>{{proposal.ProposalToDate}}</td>
                            <td>{{proposal.NetAmount}}</td>
                            <td [ngStyle]="StatusCss(proposal.ProposalExpiryStatus)">{{proposal.ProposalExpiryStatus}}</td>
                            <td>
                              <button class="btn btn-primary btn-sm" *ngIf="proposal.ProposalExpiryStatus=='Active' && proposal.isUnderSurvey==false && proposal.PayStatus==false" (click)="GetPaymentFields(proposal.ProposalNo,proposal.Product)">{{'Pay' |translate}}</button>
                              <!-- <button class="btn btn-primary btn-sm" *ngIf="proposal.ProposalExpiryStatus=='Active' && proposal.isUnderSurvey==false && proposal.PayStatus==false">{{'Edit' |translate}}</button> -->
                              <button class="btn btn-primary btn-sm" *ngIf="proposal.ProposalExpiryStatus=='Active' && proposal.isUnderSurvey==false && proposal.PayStatus==false" (click)="CancelMedmalQuoteConfirm(proposal.ProposalNo)">{{'Cancel' |translate }}</button>
                              <a class="btn btn-primary btn-sm" href="{{proposal.ProposalPrintLink}}" target="_blank" *ngIf="proposal.ProposalExpiryStatus!='Expired'||proposal.Status=='Expired'">{{'Download'|translate}}</a>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                    </div>

                  </div>

                </div>
              </div>

            </div>


            <!-- DOMESTIC HELPER START -->
            <div role="tabpanel" class="tab-pane" id="Domestic">

              <div class="row">
                <div class="col-md-12 proposals">

                  <div class="panel panel-default panel-table">
                    <div class="panel-heading">
                      <div class="row">
                        <div class="col col-xs-12">
                          <h3 class="panel-title">{{'My Domestic Proposals'|translate}}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="panel-body">
                      <table class="table table-striped table-bordered table-list">
                        <thead>
                          <tr>
                            <th>{{'Proposal No'|translate}}</th>
                            <th>{{'Proposal Type'|translate}}</th>
                            <th>{{'From Date'| translate }}</th>
                            <th>{{'Expiry Date '| translate }}</th>
                            <th>{{'Premium'|translate}}</th>
                            <th>{{'Sadad BillNo'|translate}} </th>
                            <th>{{'Sadad BillExp'|translate}} </th>
                            <th>{{'Status'|translate}} </th>
                            <th>{{'Action'|translate}}</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let proposal of DomesticProposalList">
                            <td>{{proposal.ProposalNo}}</td>
                            <td>{{proposal.ProposalType}}</td>
                            <td>{{proposal.FromDate }}</td>
                            <td style="color:red;font-weight:bold;">{{proposal.ExpiryDate }}
                            </td>
                            <td>
                              <span *ngIf="this.Lng=='ar'">(SAR){{proposal.Premium}}</span>
                              <span *ngIf="this.Lng!='ar'">{{proposal.Premium}}(SAR)</span>
                            </td>
                            <td>{{proposal.SadadBillNo }}</td>
                            <td>{{proposal.SadaBillExpDate }}</td>
                            <td [ngClass]="{
                                                            'ProposalstatusActive':proposal.IsActive==1,
                                                            'ProposalstatusInActive':proposal.IsActive==0                                                           
                                                          }">{{proposal.Status}}</td>
                            <td>

                              <button class="btn btn-primary" *ngIf="proposal.Status=='Payment Pending'" (click)="GoForPayment_DH(proposal.ProposalNo)">{{'Pay' | translate }}</button>
                              <button class="btn btn-primary" *ngIf="proposal.Status=='Payment Pending'" (click)="ProposalEdit_DH(proposal.ProposalNo)">{{'Edit' | translate }}</button>
                              <button class="btn btn-primary" *ngIf="!(proposal.PaymentStatus==1 || proposal.isActive==false)" (click)="ProposalCancel_DH(proposal.ProposalNo)">{{'Cancel' | translate }}</button>


                              <a href="{{url.PrintURL}}DomesticHelper/rpt_ProposalPrint_DH.aspx?strParm={{proposal.ProposalNo}}~331~A" download="myPolicy" class="btn btn-primary" target="_blank">{{'Download' | translate }}</a>
                            </td>

                          </tr>

                        </tbody>
                      </table>

                    </div>

                  </div>

                </div>
              </div>

            </div>
            <!-- DOMESTIC HELPER END -->
          </div>
        </div>
      </div>
    </div>


  </div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Proposals/Proposals.html